import { httpClient } from '@/network/clientController'

/** Get Unitel Agente info
@docs Não há documentação
*/
export const getUnitelAgentInfo = payload => {
	return httpClient({
		method: 'GET',
		url: 'payments/sps/unitel/agent',
        params: payload,
		isCancellable: true
	})
}

/** Pay unitel agent
@docs Não há documentação
*/
export const payUnitelAgent = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'payments/sps/unitel/pay',
        data: payload,
		operationTypeId: 35004 /* for mocks handling of tokens */
	})
}

/** Pay Movicel (integração directa)
@docs Não há documentação
*/
export const payMovicel = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'payments/sps/movicel/topup',
        data: payload,
		operationTypeId: 35011 /* for mocks handling of tokens */
	})
}

/** Get DSTV Bouquets
@docs Não há documentação
*/
export const getDSTVBouquets = payload => {
	return httpClient({
		method: 'GET',
		url: 'payments/sps/dstv/bouquets',
		isCancellable: true
	})
}

/** Get DSTV Special Products
@docs Não há documentação
*/
export const getDSTVSpecialProducts = payload => {
	return httpClient({
		method: 'GET',
		url: 'payments/sps/dstv/specialProducts',
		isCancellable: true
	})
}

/** Get DSTV Customer Details
@docs Não há documentação
*/
export const getDSTVCustomerDetails = payload => {
	return httpClient({
		method: 'GET',
		url: 'payments/sps/dstv/customer/details',
		params: payload,
		isCancellable: true
	})
}

/** Pay DSTV (integração directa)
@docs Não há documentação
*/
export const payDSTV = (payload) => {
	return httpClient({
		method: 'POST',
		url: '/payments/sps/dstv/pay',
        data: payload,
		operationTypeId: 35008 /* for mocks handling of tokens */
	})
}

/** Get Payment Info for a RUPE Reference
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetpaymentsspsrupestcreference%7Breference%7Ddetails
*/
export const getRUPEReferenceInfo = payload => {
	return httpClient({
		method: 'GET',
		url: `payments/sps/rupe/stc/reference/${payload}/details`,
		isCancellable: true
	})
}

/** Get RUPE STC
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetpaymentsspsrupestctaxTypes%7BentityNumber%7D
*/
export const getRUPESTCTypes = payload => {
	return httpClient({
		method: 'GET',
		url: `payments/sps/rupe/stc/taxTypes/${payload}`,
		isCancellable: true
	})
}

/** Pay RUPE STC (integração directa)
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetpaymentsspsrupestcpay
*/
export const payRUPESTC = (payload) => {
	return httpClient({
		method: 'POST',
		url: 'payments/sps/rupe/stc/pay',
        data: payload,
		operationTypeId: 35201 /* for mocks handling of tokens */
	})
}
